var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-pulldown",on:{"click":_vm.clickEvent}},[_c('div',{staticClass:"button-pulldown__label"},[_vm._t("default")],2),_c('select-arrow-base',{staticClass:"button-pulldown__arrow-down",attrs:{"arrowColor":_vm.arrowColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }